export const API_USER = '/api/user/';
export const API_CREATE_ACCOUNT = '/api/account/create/';
export const API_FORGOT_PASSWORD = '/api/account/password/forgot/';
export const API_RESET_PASSWORD = '/api/account/password/reset/';
export const API_LOGIN = '/api/login/';
export const API_COMPANY = '/api/company/';
export const API_ENTERPRISE = '/api/enterprise/send/';
export const API_PLANS = '/api/plan/';
export const API_INTERCOM_PRE = '/api/intercom/';
export const API_INTERCOM_POST = '/delay/';
export const TRAY_IO =
  'https://26121d52-e8a4-4d5b-8137-dbdad9ce974b.trayapp.io';

export const getIntercomEventUrl = event =>
  API_INTERCOM_PRE + event + API_INTERCOM_POST;

export const HUBSPOT_ID = '3308085';



// WEBPACK FOOTER //
// ./src/constants/api.js